"use strict";

exports.__esModule = true;
exports.experiments = exports.STAFF_RESOURCE_GROUP_ID = exports.SEPARATOR = exports.DO_NOT_CARE_STAFF = void 0;
const STAFF_RESOURCE_GROUP_ID = exports.STAFF_RESOURCE_GROUP_ID = 'staff';
const SEPARATOR = exports.SEPARATOR = ' • ';
const DO_NOT_CARE_STAFF = exports.DO_NOT_CARE_STAFF = 'DO_NOT_CARE';
let experiments = exports.experiments = /*#__PURE__*/function (experiments) {
  experiments["LOCATION_RADIOS"] = "specs.bookings.A1ButtonsSwap-A1LocationToRadios";
  return experiments;
}({});
//# sourceMappingURL=constants.js.map